module.exports = __webpack_public_path__ + "static/media/2_nsph_vagavara.a908d0ea.jpg";